<template>
  <div
    class="reference-info reference-info-detail"
  >
    <div
      id="date-header"
      class="reference-info-header"
    >
      <div
        class="header-timeindex"
      >
        <div class="header-text fs-24">
          开通前
        </div>
        <div class="header-time-text fs-20">
          <span>{{ transDate(compareB.weekBeginDateId) }}至{{ transDate(compareB.weekEndDateId) }}</span>
        </div>
      </div>
      <div class="header-vsimg">
        <img src="https://p0.meituan.net/travelcube/7f8dd6d5d2920a54f5f2ac406b994f661630.png" />
      </div>
      <div
        class="header-timeindex"
      >
        <div class="header-text fs-24">
          开通后
        </div>
        <div class="header-time-text fs-20">
          <span>{{ transDate(compareA.weekBeginDateId) }}至{{ transDate(compareA.weekEndDateId) }}</span>
        </div>
      </div>
    </div>
    <div
      v-if="data && data.contents"
      class="reference-info-content"
    >
      <div
        v-if="isShowModlues('flow')"
        class="reference-info-card"
      >
        <div>
          <span class="fs-32">流量转化</span>
        </div>
        <div class="card-content">
          <div class="card-content-th">
            <div class="th-text">
              曝光人数
            </div>
            <div class="th-arrowdown">
              <img src="https://p0.meituan.net/travelcube/0ffbcbadd137e11e3a5fcdae880b54d8535.png" />
            </div>
            <div class="th-text">
              浏览人数
            </div>
            <div class="th-arrowdown">
              <img src="https://p0.meituan.net/travelcube/0ffbcbadd137e11e3a5fcdae880b54d8535.png" />
            </div>
            <div class="th-text">
              兴趣人数
            </div>
            <div class="th-arrowdown">
              <img src="https://p0.meituan.net/travelcube/0ffbcbadd137e11e3a5fcdae880b54d8535.png" />
            </div>
            <div class="th-text">
              交易人数
            </div>
          </div>
          <div class="card-content-vs">
            <div class="card-content-vsheader">
              <span>开通前</span>
              <img src="https://p0.meituan.net/travelcube/628159ed1b966eb0755552d2d4b4254f1251.png" />
              <span>开通后</span>
            </div>
            <div style="display:flex">
              <div class="card-content-vs1">
                <div class="vs-outer">
                  <div
                    class="vs-inner"
                    style="width: 100%"
                  >
                    <span>{{ compareB.totalViewCnt }}</span>
                  </div>
                </div>
                <div class="vs-outer">
                  <div
                    :style="`margin-left: ${100 - getBarWidth(compareB.totalPv, compareB.totalViewCnt)}%`"
                    class="vs-inner"
                  >
                    <span>{{ compareB.totalPv }}</span>
                  </div>
                </div>
                <div class="vs-outer">
                  <div
                    :style="`margin-left: ${100 - getBarWidth(compareB.totalClickCnt, compareB.totalViewCnt)}%`"
                    class="vs-inner"
                  >
                    <span>{{ compareB.totalClickCnt }}</span>
                  </div>
                </div>
                <div class="vs-outer">
                  <div
                    :style="`margin-left: ${100 - getBarWidth(compareB.totalClickCnt, compareB.totalViewCnt)}%`"
                    class="vs-inner"
                  >
                    <span>{{ compareB.totalOrderQuantity }}</span>
                  </div>
                </div>
              </div>
              <div class="card-content-vs2">
                <div class="vs-outer">
                  <div
                    class="vs-inner"
                    style="width: 100%"
                  >
                    <span>{{ compareA.totalViewCnt }}</span>
                  </div>
                </div>
                <div class="vs-outer">
                  <div
                    :style="`width: ${getBarWidth(compareA.totalPv, compareA.totalViewCnt)}%`"
                    class="vs-inner"
                  >
                    <span>{{ compareA.totalPv }}</span>
                  </div>
                </div>
                <div class="vs-outer">
                  <div
                    :style="`width: ${getBarWidth(compareA.totalClickCnt, compareA.totalViewCnt)}%`"
                    class="vs-inner"
                  >
                    <span>{{ compareA.totalClickCnt }}</span>
                  </div>
                </div>
                <div class="vs-outer">
                  <div
                    :style="`width: ${getBarWidth(compareA.totalClickCnt, compareA.totalViewCnt)}%`"
                    class="vs-inner"
                  >
                    <span>{{ compareA.totalOrderQuantity }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card-content-desc">
            <div class="desc-text">
              <span>对比</span>
              <img :src="getIconByDiff(compareA.totalViewCntWowPct)" />
              <span :style="`color: ${getColorByDiff(compareA.totalViewCntWowPct)}`">{{ compareA.totalViewCntWowPct }}</span>
            </div>
            <div class="desc-text">
              <span>对比</span>
              <img :src="getIconByDiff(compareA.totalPvWowPct)" />
              <span :style="`color: ${getColorByDiff(compareA.totalPvWowPct)}`">{{ compareA.totalPvWowPct }}</span>
            </div>
            <div class="desc-text">
              <span>对比</span>
              <img :src="getIconByDiff(compareA.totalClickCntWowPct)" />
              <span :style="`color: ${getColorByDiff(compareA.totalClickCntWowPct)}`">{{ compareA.totalClickCntWowPct }}</span>
            </div>
            <div class="desc-text">
              <span>对比</span>
              <img :src="getIconByDiff(compareA.totalOrderQuantityWowPct)" />
              <span :style="`color: ${getColorByDiff(compareA.totalOrderQuantityWowPct)}`">{{ compareA.totalOrderQuantityWowPct }}</span>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="isShowModlues('flow')"
        class="reference-info-card"
      >
        <div>
          <span class="fs-32">流量趋势</span>
        </div>
        <div class="card-content">
          <div class="card-content-tabs">
            <div
              v-for="(item, index) in tabsData"
              :key="index"
              :class="{'active': index === activeTab}"
              class="card-content-tab"
              @click="changeTab(index)"
            >
              {{ item.name }}
            </div>
          </div>
        </div>
        <div class="card-content-charts">
          <line-charts ref="tabLineCharts" />
        </div>
      </div>
      <div
        v-if="isShowModlues('flow')"
        class="reference-info-card"
      >
        <div>
          <span class="fs-32">门店流量环境</span>
        </div>
        <div class="card-content card-content-poiflow">
          <div class="card-content-th">
            <div class="content-th-text">
              城市同品类排名
            </div>
            <div class="content-th-text">
              商圈同品类排名
            </div>
          </div>
          <div class="card-content-vs">
            <div class="card-content-vsheader">
              <span>开通前</span>
              <img src="https://p0.meituan.net/travelcube/628159ed1b966eb0755552d2d4b4254f1251.png" />
              <span>开通后</span>
            </div>
            <div style="display:flex">
              <div class="card-content-vs1">
                <div class="vs-outer">
                  <div
                    :style="`margin-left: ${100 - getRankBarWidth(compareB.totalFlowCntBareaRank, compareB.citySecondCateCnt)}%`"
                    class="vs-inner"
                  >
                    <span>{{ compareB.totalFlowCntCityRank }} / {{ compareB.citySecondCateCnt }}</span>
                  </div>
                </div>
                <div class="vs-outer">
                  <div
                    :style="`margin-left: ${100 - getRankBarWidth(compareB.totalFlowCntBareaRank, compareB.bareaSecondCateCnt)}%`"
                    class="vs-inner"
                  >
                    <span>{{ compareB.totalFlowCntBareaRank }} / {{ compareB.bareaSecondCateCnt }}</span>
                  </div>
                </div>
              </div>
              <div class="card-content-vs2">
                <div class="vs-outer">
                  <div
                    :style="`width: ${getRankBarWidth(compareA.totalFlowCntBareaRank, compareA.citySecondCateCnt)}%`"
                    class="vs-inner"
                  >
                    <span>{{ compareA.totalFlowCntCityRank }} / {{ compareA.citySecondCateCnt }}</span>
                  </div>
                </div>
                <div class="vs-outer">
                  <div
                    :style="`width: ${getRankBarWidth(compareA.totalFlowCntBareaRank, compareA.bareaSecondCateCnt)}%`"
                    class="vs-inner"
                  >
                    <span>{{ compareA.totalFlowCntBareaRank }} / {{ compareA.bareaSecondCateCnt }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="isShowModlues('trade')"
        class="reference-info-card"
      >
        <div>
          <span class="fs-32">交易数据展示</span>
        </div>
        <div class="card-content content-trade">
          <div
            v-for="(item, index) in tradeTabsData"
            :key="index"
            :class="{'active': tradeActiveTab === index}"
            class="card-content-trade"
            @click="changeTradeTab(index)"
          >
            <div class="content-title">
              {{ item.name }}
            </div>
            <div class="content-value">
              {{ compareA[item.key] }}<span class="content-value-suffix">开通后</span>
            </div>
            <div class="desc-text">
              <span>对比</span>
              <img :src="getIconByDiff(compareA[item.diff])" />
              <span :style="`color: ${getColorByDiff(compareA[item.diff])}`">{{ compareA[item.diff] }}</span>
            </div>
          </div>
        </div>
        <div class="card-content-charts">
          <line-charts ref="tradeLineCharts" />
        </div>
      </div>
      <div
        v-if="isShowModlues('comment')"
        class="reference-info-card"
      >
        <div>
          <span class="fs-32">评论组成分析</span>
        </div>
        <div class="card-content content-trade">
          <div
            v-for="(item, index) in commentTabsData"
            :key="index"
            :class="{'active': commentActiveTab === index}"
            class="card-content-trade"
            @click="changeCommentTab(index)"
          >
            <div class="content-title">
              {{ item.name }}
            </div>
            <div class="content-value">
              {{ compareA[item.key] }}<span class="content-value-suffix">开通后</span>
            </div>
            <div class="desc-text">
              <span>对比</span>
              <img :src="getIconByDiff(compareA[item.diff])" />
              <span :style="`color: ${getColorByDiff(compareA[item.diff])}`">{{ compareA[item.diff] }}</span>
            </div>
          </div>
        </div>
        <div class="card-content-charts">
          <line-charts ref="commentLineCharts" />
        </div>
      </div>
      <template v-for="(item, index) in resourceConf">
        <div
          v-if="isShowModlues(item.module)"
          :key="index"
          class="reference-info-card"
        >
          <div>
            <span class="fs-32">{{ item.title }}</span>
          </div>
          <div class="card-content">
            <div
              v-for="(ind, idx) in item.inds"
              :key="idx"
              class="card-content-resource"
            >
              <div class="content-title">
                {{ ind.name }}
              </div>
              <div class="content-value">
                {{ compareA[ind.key] || '-' }}
              </div>
              <div
                v-if="'diff' in ind"
                class="desc-text"
              >
                <span>对比</span>
                <img :src="getIconByDiff(compareA[ind.diff])" />
                <span :style="`color:${getColorByDiff(compareA[ind.diff])}`">{{ compareA[ind.diff] }}</span>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import {
  mapState,
} from 'vuex';
import Icon from 'vant/lib/icon';
import Button from 'vant/lib/button';
import Cell from 'vant/lib/cell';
import CellGroup from 'vant/lib/cell-group';
import Tag from 'vant/lib/tag';
import MarketingApi from '@/api/marketing';

import LineCharts from './components/line.charts';

import 'vant/lib/icon/style';
import 'vant/lib/button/style';
import 'vant/lib/cell/style';
import 'vant/lib/cell-group/style';
import 'vant/lib/tag/style';


const MODULES = [{
  value: 'flow',
  label: '流量模块',
}, {
  value: 'trade',
  label: '交易数据',
}, {
  value: 'comment',
  label: '评论数据',
}, {
  value: 'advertise',
  label: '近30日广告通',
}, {
  value: 'business',
  label: '近30日生意通数据',
}, {
  value: 'star',
  label: '近90日明星店铺数据',
}];

export default {
  name: 'ReferenceInfoDetail',
  components: {
    [Button.name]: Button,
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Tag.name]: Tag,
    LineCharts,
  },
  data() {
    return {
      activeTab: 0,
      tradeActiveTab: 0,
      commentActiveTab: 0,
      data: {},
      MODULES,
      tabsData: [{
        name: '曝光',
        key: 'viewCntList',
      }, {
        name: '浏览',
        key: 'pvList',
      }, {
        name: '感兴趣',
        key: 'clickCntList',
      }, {
        name: '交易',
        key: 'orderQuantityList',
      }],
      tradeTabsData: [{
        name: '订单数量（个）',
        key: 'totalOrderQuantity',
        lineKey: 'orderQuantityList',
        diff: 'totalOrderQuantityWowPct',
      }, {
        name: '退款单数量（个）',
        key: 'totalRefundQuantity',
        lineKey: 'refundQuantityList',
        diff: 'totalRefundQuantityWowPct',
      }],
      commentTabsData: [{
        name: '评价数',
        key: 'totalScoreCnt',
        lineKey: 'scoreCntList',
        diff: 'totalOrderQuantityWowPct',
      }, {
        name: '点赞数',
        key: 'totalPoiVoteCnt',
        lineKey: 'poiVoteCntList',
        diff: 'totalRefundQuantityWowPct',
      }],

      resourceConf: [{
        module: 'advertise',
        title: '近30日广告通数据',
        inds: [{
          name: 'PV',
          key: 'advPv',
          diff: 'advPvQoq',
        }, {
          name: 'UV',
          key: 'advUv',
          diff: 'advUvQoq',
        }],
      }, {
        module: 'business',
        title: '近30日生意通数据',
        inds: [{
          name: '订单数',
          key: 'bizClearOrderCnt',
          diff: 'bizClearOrderCntQoq',
        }, {
          name: '计入生意通订单数',
          key: 'bizManOrderCnt',
          diff: 'bizManOrderCntQoq',
        }],
      }, {
        module: 'star',
        title: '近90日明星店铺数据数据',
        inds: [{
          name: '提报次数',
          key: 'starEffectCount',
        }, {
          name: '进入榜单次数',
          key: 'starTopDays',
        }],
      }],
    };
  },
  computed: {
    ...mapState(['isAgent', 'poiList', 'accountType']),
    ...mapState('billModule', ['customerId']),
    compareA() {
      if (this.data && this.data.contents) {
        return this.data.contents[0];
      }
      return {};
    },
    compareB() {
      if (this.data && this.data.contents) {
        return this.data.contents[1];
      }
      return {};
    },
  },

  async mounted() {
    await this.getData();
    this.resetTabs();
  },

  methods: {
    transDate(str) {
      return String(str || '').replace(/(\d{4})(\d{2})/, (a, b, c) => `${b}/${c}/`);
    },
    resetTabs() {
      this.changeTab();
      this.changeTradeTab();
      this.changeCommentTab();
    },
    isShowModlues(module) {
      if (this.data && this.data.modules) {
        return this.data.modules.indexOf(module) !== -1;
      }
      return true;
    },
    getBarWidth(current, total) {
      let width = 100;
      const len = String(current || '').length;
      try {
        width = (Math.sqrt(current) / Math.sqrt(total)) * 100 + (len * 5);
      } catch (e) {
        width = 40;
      }
      return Math.min(Math.max(width, len * 10), 100);
    },
    getRankBarWidth(current, total) {
      let width = 100;
      const len = String(current || '').length + String(total || '').length + 2;
      try {
        width = (Math.sqrt(current) / Math.sqrt(total)) * 100 + (len * 5);
      } catch (e) {
        width = 40;
      }
      return Math.min(Math.max(width, len * 10), 100);
    },
    getIconByDiff(value) {
      const decrease = String(value).indexOf('-') === 0;
      return decrease ? 'https://p0.meituan.net/travelcube/35a104a2d2b4ab246a1c4920531ab70e367.png' : 'https://p0.meituan.net/travelcube/bf53ecbaaf2866b83ef06bd95463e9cf396.png';
    },
    getColorByDiff(value) {
      const decrease = String(value).indexOf('-') === 0;
      return decrease ? '#FF404F' : '#12B355';
    },
    async getData() {
      const { reportId } = this.$route.query;
      const { data } = await MarketingApi.getReferenceDetail(this.customerId, reportId);
      this.data = data;
    },
    getChartsData(key) {
      const result = {
        data: [],
        legend: [],
      };
      if (this.data && this.data.contents && this.data.contents.length) {
        result.legend = this.data.contents[0].dtList;
        result.data = this.data.contents.map((item, index) => {
          const temp = {
            name: index === 0 ? '开通后' : '开通前',
            data: this.data.contents[index][key],
            type: 'line',
            smooth: true,
          };
          return temp;
        }).reverse();
      }
      return result;
    },
    changeTab(index = 0) {
      this.activeTab = index;
      const key = this.tabsData[this.activeTab].key;
      const data = this.getChartsData(key);
      if (this.$refs.tabLineCharts) {
        this.$refs.tabLineCharts.renderCharts(data, '单位：人数');
      }
    },
    changeTradeTab(index = 0) {
      this.tradeActiveTab = index;
      const key = this.tradeTabsData[this.tradeActiveTab].lineKey;
      const data = this.getChartsData(key);
      if (this.$refs.tradeLineCharts) {
        this.$refs.tradeLineCharts.renderCharts(data, '单位：个');
      }
    },
    changeCommentTab(index = 0) {
      this.commentActiveTab = index;
      const key = this.commentTabsData[this.commentActiveTab].lineKey;
      const data = this.getChartsData(key);
      if (this.$refs.commentLineCharts) {
        this.$refs.commentLineCharts.renderCharts(data, '单位：个');
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.reference-info{
  background: #f7f7f7;
  min-height: 100vh;
  text-align: left;
  .fs-20{
    font-size: 20px;
    line-height: 20px;
  }
  .fs-24{
    font-size: 24px;
    line-height: 24px;
  }
  .fs-32{
    font-size: 32px;
    line-height: 38px;
  }
  .reference-info-header{
    padding: 25px 36px;
    background: #fff;
    display: flex;
    .header-timeindex{
      width: 310px;
      .header-time-text{
        margin-top: 10px;
        color:#166FF7;
        .van-icon{
          background: #F0F6FF;
          margin-left: 10px;
          transform: scale(0.8);
        }
      }
    }
    .header-vsimg{
      width: 48px;
      height: 48px;
      margin: 4px 10px;
      img{
        width: 48px;
        height: 48px;
      }
    }
  }
  .reference-info-card{
    background: #fff;
    margin: 22px 18px 30px;
    min-height: 100px;
    padding: 30px 22px;
    border-radius: 20px;
  }
  .card-content{
    display: flex;
    margin-top: 20px;
  }
  .card-content-th{
    width: 136px;
    .th-text{
      font-size: 24px;
      line-height: 42px;
      height: 42px;
      background: #f7f7f7;
      width: 117px;
      text-align: center;
      color: #535353;
      &:first-child{
        margin-top: 52px;
      }
    }
    .th-arrowdown{
      width: 117px;
      text-align: center;
      img{
        width: 15px;
        height: 22px;
        margin: 8px auto;
      }
    }
  }
  .card-content-vs{
    width: 360px;
    height: 370px;
    background: linear-gradient(90deg, #FFF9DE 0,#FFF9DE 50%, #F0F6FF 50%, #F0F6FF 100%);
  }
  .card-content-vsheader{
    text-align: center;
    margin: auto;
    height: 37px;
    line-height: 37px;
    font-size: 24px;
    margin-top: 8px;
    img{
      width: 26px;
      height: 37px;
      margin: 0 8px;
      position: relative;
      display: inline;
    }
  }
  .card-content-vs1{
    width: 180px;
    .vs-outer{
      margin-left: 18px;
      text-align: right;
    }
    .vs-inner{
      background: #FFD103;
      border-radius: 6px 0 0 6px;
    }
  }
  .card-content-vs2{
    width: 180px;
  }
  .vs-outer{
    width: 162px;
    margin-top: 50px;
    &:first-child{
      margin-top: 20px;
    }
  }
  .vs-inner{
    background: #4DA1F5;
    color: #fff;
    font-size: 24px;
    line-height: 35px;
    height: 35px;
    box-sizing: border-box;
    padding: 0 5px;
    border-radius: 0 6px 6px 0;
  }
  .card-content-desc{
    margin-left: 14px;
    width: 176px;
  }
  .desc-text{
    height: 85px;
    display: flex;
    &:first-child{
      margin-top: 54px;
    }
    img{
      width: 14px;
      height: 20px;
      margin: 7px 4px;
    }
    span{
      min-width: 50px;
      font-size: 20px;
      color: #12B355;
      line-height: 35px;
      &:first-child{
        color: #999;
      }
    }
  }
  .card-content-poiflow {
    .card-content-th{
      width: 200px;
      margin: 28px 30px 0 0;
      text-align: right;
    }
    .content-th-text{
      height: 35px;
      margin-top: 40px;
      color:#666666;
      font-size: 20px;
      line-height: 35px;
    }
    .card-content-vs{
      width: 440px;
      height: 200px;
    }
    .vs-outer{
      width:200px;
      margin-top: 40px;
      &:first-child{
        margin-top: 30px
      }
    }
    .card-content-vs1{
      width: 220px;
      .vs-outer{
        margin-left: 20px;
      }
    }
    .card-content-vs2{
      width: 220px;
    }
  }
  .card-content-poidesc{
    width: 670px;
    box-sizing: border-box;
    display: flex;
    background: linear-gradient(90deg, #FFF9DE 0,#FFF9DE 50%, #F0F6FF 50%, #F0F6FF 100%);
    min-height: 200px;
    padding: 10px 10px;
    .poidesc-outer{
      display: flex;
    }
    .poidesc-title{
      width: 240px;
      flex: 1;
      font-size: 18px;
      line-height: 24px;
      text-align: right;
      display: inline-block;
      margin-top: 24px;
    }
    .poidesc-value{
      width: 60px;
      margin-left: 24px;
      font-size: 24px;
      text-align: left;
      display: inline-block;
      color:#FF9148;
      margin-top: 24px;
    }
    .card-content-desc1{
      width: 50%;
    }
    .card-content-desc2{
      width: 50%;
    }
  }
  .card-content-tabs{
    margin-top: 10px;
    display: flex;
    width: 100%;
    .card-content-tab{
      width: 25%;
      flex: 1;
      height: 52px;
      line-height: 52px;
      text-align:center;
      font-size: 24px;
      color: #333;
      background: #FFFFFF;
      border: 1px solid #E5E5E5;
      border-left: 0;
      &:first-child{
        border-left: 1px solid #E5E5E5;
        border-radius: 50px 0 0 50px;
      }
      &:last-child{
        border-radius: 0 50px 50px 0;
      }
      &.active{
        background: #4DA1F5;
        color: #fff;
        border-color: #4DA1F5;
      }
    }
  }
  .card-header-desc{
    color: #1677FF;
    text-align: right;
    margin-top: 20px;
    font-size: 24px;
  }
  .card-content-resource,.card-content-trade{
    width: 200px;
    flex: 1;
    &.active{
      background: #F9FCFF;
      border: 2px solid #1677FF;
    }
    .content-title{
      margin-top: 12px;
      font-size: 24px;
      color: #666;
    }
    .content-value{
      font-size: 36px;
      margin-top: 24px;
    }
    .content-value-suffix{
      font-size: 22px;
      margin-left: 8px;
    }
    .desc-text{
      margin: 0!important;
      margin-top: 24px!important;
      height: auto;
    }
  }
  .card-content-trade{
    border: 1px solid #E5E5E5;
    margin-left: 14px;
    padding: 10px 20px;
    border-radius: 12px;
    position: relative;
    min-width: 328px;
    max-width: 328px;
    box-sizing: border-box;
    &:first-child{
      margin-left: 0;
    }
  }
  .card-content-charts{
    margin-top: 30px;
  }
  .card-content-resource{
    &:last-child{
      margin-left: 180px;
    }
  }
}
.reference-info-detail{
  .header-text{
    display: none;
  }
  .header-time-text{
    font-size: 24px;
    line-height: 40px;
    text-align: center;
  }
}
.reference-info-detail{
  .reference-info-content{
    padding-bottom: 30px;
  }
}
</style>
